import React from 'react'
import ReactDOM from 'react-dom'
import '../styles/Modal.css'
// import "../../componentes/styles/Modal.css";

function DespachoModal (props) {
    if(!props.isOpen){
        return null
    }
    return ReactDOM.createPortal(
        <div className="Modal despacho-modal" tabIndex='-1'>
                <div className="Modal__container modal-dialog modal-content">
                    <div className="modal-header">
                        <h5 className="modal-header-title">{props.title}</h5>
                        <button className="close" onClick={props.onClose}>X</button>
                    </div>
                    <div className="modal-body bg-color">
                        {props.children}
                    </div>
                    <div className="modal-footer bg-color-footer">
                        {props.footerButtons ? props.footerButtons.map((btn, idx) => (
                            <React.Fragment key={idx}>
                                {idx > 0 && <span style={{ width: 8, display: 'inline-block' }} />}
                                {React.cloneElement(btn, { type: btn.props.type || 'button' })}
                            </React.Fragment>
                        )) : null}
                    </div>
                </div>
        </div>
        ,
        
        document.getElementById('modal')
    );
}

export default DespachoModal